export const floorPlanLayoutKeys = {
  all: ["quantitySurveyorFloorPlanLayout"] as const,
  detail: (floorPlanId: number | undefined) =>
    [...floorPlanLayoutKeys.all, floorPlanId] as const,
};
